<template>
  <header>
    <!-- Top Bar -->
    <div class="top-bar">
      <div class="container">
        <div class="contact-info">
          <span class="email">
            <i class="fa fa-envelope"></i>
            <a href="mailto:info@chinastroll.com">info@chinastroll.com</a>
          </span>
        </div>
        <div class="search">
          <SearchBox />
        </div>
      </div>
    </div>
    <!-- Navigation Bar -->
    <div class="nav-bar">
      <div class="container">
        <!-- Logo -->
        <div class="logo">
          <router-link to="/">
            <img :src="logoImage" alt="China Stroll Logo" />
          </router-link>
        </div>
        <!-- Navigation Menu -->
        <nav class="main-nav">
          <ul>
            <li><router-link to="/explore">Explore</router-link></li>
            <li><router-link to="/culture">Culture</router-link></li>
            <li><router-link to="/stories">Stories</router-link></li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import SearchBox from './SearchBox.vue';
import logoImage from '@/assets/images/logo.png';

export default {
  name: 'Header',
  components: {
    SearchBox,
  },
  data() {
    return {
      logoImage,
    };
  },
};
</script>

<style scoped>
/* Top Bar Styles */
.top-bar {
  background-color: #f8f8f8;
  padding: 5px 0;
}

.top-bar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top-bar .contact-info {
  font-size: 14px;
  color: #333;
}

.top-bar .contact-info a {
  color: #333;
  text-decoration: none;
}

.top-bar .search {
  display: flex;
  align-items: center;
}

/* Navigation Bar Styles */
.nav-bar {
  background-color: #fff;
  border-bottom: 1px solid #eaeaea;
}

.nav-bar .container {
  display: flex;
  align-items: center;
  /* Removed justify-content: space-between; */
  padding: 10px 0;
}

.logo img {
  height: 60px; /* Adjust logo height as needed */
}

/* Adjusted the spacing between logo and navigation menu */
.nav-bar .main-nav {
  margin-left: 50px; /* Adjust this value to bring the menu closer or further from the logo */
}

/* Updated nav styles */
.main-nav ul {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

.main-nav ul li {
  margin-left: 30px; /* Spacing between menu items */
}

.main-nav ul li:first-child {
  margin-left: 0;
}

.main-nav ul li a {
  text-decoration: none;
  color: #333;
  font-size: 18px;
  font-weight: 500;
}

.main-nav ul li a:hover {
  color: #007bff; /* Change color on hover */
}

@media (max-width: 768px) {
  /* Responsive adjustments for smaller screens */
  .nav-bar .container {
    flex-direction: column;
    align-items: flex-start;
  }

  .main-nav {
    margin-left: 0;
    width: 100%;
    margin-top: 10px;
  }

  .main-nav ul {
    flex-direction: column;
  }

  .main-nav ul li {
    margin-left: 0;
    margin-bottom: 10px;
  }
}
</style>